import { Switch, Route } from "react-router-dom";
/* import { Provider } from "react-redux"; */

/* import Dashboard from "./components/Dashboard/Dashboard"; */
import Prototype from "./components/Prototype/Prototype";
/* import SimpleDemo from "./components/SimpleDemo/SimpleDemo"; */
// import Dashboard from "./pages/Dashboard/Dashboard";
import Orders from "./pages/Orders/Orders";
import OrdersAdd from "./pages/Orders/Add/Add";
import OrdersDemo from "./pages/Orders/Demo/Demo";
import OrdersPickList from "./pages/Orders/PickList/PickList";
import OrdersPickListDetails from "./pages/Orders/PickList/PickListDetails/PickListDetails";
import OrdersPickListDetailsPrint from "./pages/Orders/PickList/PickListDetailsPrint/PickListDetailsPrint";
import OrderDetails from "./pages/Orders/Details/Details";
import OrdersPrint from "./pages/Orders/Print/Print";
import OrderInvoice from "./pages/Orders/Invoice/Invoice";
import OrderInvoicePrint from "./pages/Orders/Invoice/Print/Print";
import Inventory from "./pages/Inventory/Inventory";
import Cart from "./pages/Cart/Cart";
import Users from "./pages/Admin/Users/Users";
// import Customers from "./pages/Admin/Customers/Customers";
import AddUser from "./pages/Admin/Users/AddUser/AddUser";
// import AddCustomer from "./pages/Admin/Customers/AddCustomer/AddCustomer";
// import InventoryCustomer from "./pages/Admin/Customers/InventoryCustomer/InventoryCustomer";
import ReceiptDifference from "./pages/Admin/ReceiptDifference/ReceiptDifference";
// import InventoryAdd from "./pages/Inventory/Add/Add";
import Setup from "./pages/Setup/Setup";
// import Sync from "./pages/Sync/Sync";
import WarehouseAdd from "./pages/Setup/Add/Add";
import OrderlistPrototype from "./features/OrderlistPrototype/pages/OrderlistPrototype";
import PriceRefresh from "./pages/Admin/PriceRefresh/PriceRefresh";
import Bulk from "./pages/Inventory/Bulk/Bulk";
import EmailInvoices from "./pages/Admin/EmailInvoices/EmailInvoices";
import Orderlists from "./pages/Admin/Orderlists/Orderlists";
import MissingItems from "./pages/Admin/MissingItems/MissingItems";
import ExportInvoices from "./pages/Admin/ExportInvoices/ExportInvoices";
import Reporting from "./pages/Admin/Reporting/Reporting";
import ExportOrderlists from "./pages/Admin/ExportOrderlists/ExportOrderlists";

// todo: keep improving component splitting and code re-usability
import Customers from "./features/Customers/pages/Customers";
import CustomerAdd from "./features/Customers/pages/CustomerAdd";
import CustomerOrderlists from "./features/Customers/pages/CustomerOrderlists";
import CustomerFees from "./features/Customers/pages/CustomerFees";

import ProductAdd from "./features/Products/pages/ProductAdd";
import ProductFees from "./features/Products/pages/ProductFees";
import GenerateInvoices from "./pages/Admin/GenerateInvoices/GenerateInvoices";
import PrintPicklists from "./pages/Admin/PrintPicklists/PrintPicklists";
import MergeOrders from "./pages/Admin/MergeOrders/MergeOrders";
import ItemCodesAdd from "./pages/ItemCodes/Add/Add";
import ReceiptUpload from "./features/Receipt/pages/UploadReceipt";
import Sync from "./features/Inventory/pages/Sync";
import ValidateStock from "./features/Orders/pages/ValidateStock";
import OrderFollowup from "./pages/Admin/OrderFollowup/OrderFollowup";
import Overrides from "./features/Inventory/pages/Overrides";
import Products from "./features/Inventory/pages/Products";
import Storefront from "./features/Inventory/pages/Storefront";
import Categories from "./features/Inventory/pages/Categories";
import StorefrontBanners from "./features/Storefront/pages/StorefrontBanners";
import StorefrontBlocks from "./features/Storefront/pages/StorefrontBlocks";
import FinalizeInvoices from "./pages/Admin/FinalizeInvoices/FinalizeInvoices";
import VerifyEmail from "./pages/Login/VerifyEmail";
import SaleTaxRate from "./features/Customers/pages/SaleTaxRate";
import BulkImport from "./features/Customers/pages/BulkImport";
import ParStock from "./features/Inventory/pages/ParStock";

export const linksData = [
  /* {
    text: "Storefront",
    to: "storefront",
    icon: "ViewQuilt",
    component: Storefront,
  }, */
  {
    text: "Orders",
    to: "orders",
    icon: "Dashboard",
    component: Orders,
    className: "orders-link",
  },
  {
    text: "Inventory",
    to: "inventory",
    icon: "ListAlt",
    component: Inventory,
  },
  {
    text: "Item Codes",
    to: "itemcodes",
    icon: "ListAlt",
    component: Inventory,
  },
  {
    text: "Customer Location",
    to: "customers",
    icon: "Store",
    component: Customers,
  },
  {
    text: "Users",
    to: "users",
    icon: "Person",
    component: Users,
  },
  {
    text: "Receipt Difference",
    to: "receiptDifference",
    icon: "Receipt",
    component: ReceiptDifference,
  },
  {
    text: "Price Refresh",
    to: "priceRefresh",
    icon: "SwapCalls",
    component: PriceRefresh,
  },
  {
    text: "Order Management",
    to: "printPicklists",
    icon: "RequestQuote",
    component: PrintPicklists,
  },
  {
    text: "Reporting",
    to: "reporting",
    icon: "Summarize",
    component: Reporting,
  },
  {
    text: "Setup",
    to: "setup",
    icon: "Settings",
    component: Setup,
  },
  {
    text: "Order Guide Public",
    to: "orderlistPublic",
    icon: "Dashboard",
    component: Orderlists,
  },
  {
    text: "Order Guide Prototype",
    to: "orderlistPrototype",
    icon: "ListAlt",
    component: OrderlistPrototype,
  },
];

export const Router = () => {
  return (
    <Switch>
      <Route exact path="/" component={Orders} />
      <Route exact path="/user/add" component={AddUser} />
      <Route exact path="/user/:id" component={AddUser} />
      <Route exact path="/customer/add" component={CustomerAdd} />
      <Route exact path="/customer/:id" component={CustomerAdd} />
      <Route
        exact
        path="/customer/:id/orderlists"
        component={CustomerOrderlists}
      />
      <Route exact path="/customer/:id/fees" component={CustomerFees} />
      <Route exact path="/product/add" component={ProductAdd} />
      <Route exact path="/product/:id" component={ProductAdd} />
      <Route exact path="/product/:id/fees" component={ProductFees} />
      <Route exact path="/inventory/bulk" component={Bulk} />
      <Route exact path="/inventory/sync" component={Sync} />
      <Route exact path="/inventory/overrides" component={Overrides} />
      <Route exact path="/inventory/categories" component={Categories} />
      <Route exact path="/inventory/parstock" component={ParStock} />
      <Route exact path="/products" component={Products} />
      <Route exact path="/itemcodes/:id" component={ItemCodesAdd} />
      <Route exact path="/orders/add" component={OrdersAdd} />
      <Route exact path="/orders/picklist" component={OrdersPickList} />
      <Route
        exact
        path="/orders/picklist/details"
        component={OrdersPickListDetails}
      />
      <Route
        exact
        path="/orders/picklist/details/print"
        component={OrdersPickListDetailsPrint}
      />
      <Route
        exact
        path="/orders/picklist/validate-stock"
        component={ValidateStock}
      />
      <Route exact path="/order/:id" component={OrderDetails} />
      <Route exact path="/order/:id/invoice" component={OrderInvoice} />
      <Route exact path="/order/:id/print" component={OrdersPrint} />
      <Route
        exact
        path="/order/:id/invoice/print"
        component={OrderInvoicePrint}
      />
      <Route exact path="/cart" component={Cart} />
      <Route exact path="/warehouse/add" component={WarehouseAdd} />
      <Route exact path="/warehouse/:id" component={WarehouseAdd} />
      <Route exact path="/scan" component={Prototype} />
      <Route exact path="/demo/:furl" component={OrdersDemo} />
      <Route exact path="/missingItems" component={MissingItems} />
      <Route exact path="/emailInvoices" component={EmailInvoices} />
      <Route exact path="/exportInvoices" component={ExportInvoices} />
      <Route exact path="/exportOrderlists" component={ExportOrderlists} />
      <Route exact path="/generateInvoices" component={GenerateInvoices} />
      <Route exact path="/finalizeInvoices" component={FinalizeInvoices} />
      <Route exact path="/mergeOrders" component={MergeOrders} />
      <Route exact path="/receipt/upload" component={ReceiptUpload} />
      <Route exact path="/orderFollowup" component={OrderFollowup} />
      <Route exact path="/storefront" component={Storefront} />
      <Route exact path="/storefront/banners" component={StorefrontBanners} />
      <Route exact path="/storefront/blocks" component={StorefrontBlocks} />
      <Route exact path="/verify/:uid/:token" component={VerifyEmail} />
      <Route exact path="/saletaxrate" component={SaleTaxRate} />
      <Route exact path="/clbulkimport" component={BulkImport} />
      {linksData.map((item) => (
        <Route
          key={item.text}
          exact
          path={"/" + item.to}
          component={item.component}
        />
      ))}
    </Switch>
  );
};

export default Router;
